import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import AddIcon from '@mui/icons-material/Add';
import { IconButton, Link, MenuList, Tooltip, Typography } from '@mui/material';

import { useTopicStore } from '@/dmdrive/topic/components/Topic/TopicStore';

import { LeftSidebarBlock } from '../LeftSidebar.styles';

import SnapshotRow from './SnapshotRow/SnapshotRow';

function Snapshots() {
  const { isControlDisabled, isCreatingSnapshot, createSnapshot, topicSnapshots } = useTopicStore();

  const onCreateSnapshotHandler = useCallback(() => {
    if (isControlDisabled || isCreatingSnapshot) {
      return;
    }

    createSnapshot();
  }, [isControlDisabled, isCreatingSnapshot]);

  return (
    <div>
      <LeftSidebarBlock isHeader>
        <Typography variant="h6">Snapshots</Typography>

        <Tooltip title="Add snaphot for current view">
          <IconButton loading={isCreatingSnapshot} onClick={onCreateSnapshotHandler} disabled={isControlDisabled}>
            <AddIcon />
          </IconButton>
        </Tooltip>
      </LeftSidebarBlock>

      {topicSnapshots.length === 0 && (
        <Typography variant="caption" align="center" component="div" margin="1rem">
          <div>You don't have any snapshot.</div>

          <div>
            <span>You can </span>

            <Link onClick={onCreateSnapshotHandler} sx={{ cursor: 'pointer' }}>
              create
            </Link>

            <span> first one.</span>
          </div>
        </Typography>
      )}

      <MenuList disablePadding>
        {topicSnapshots.map((snapshot) => (
          <SnapshotRow key={snapshot.id} snapshot={snapshot} />
        ))}
      </MenuList>
    </div>
  );
}

export default observer(Snapshots);
